import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, interval } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';
import { ClockService } from '../../../../shared/environment-info/clock.service';
import { GeolocationService } from '../../../../shared/environment-info/geolocation.service';
import { LocationWeather } from '../../../../shared/environment-info/weather.model';
import { WeatherService } from '../../../../shared/environment-info/weather.service';

const WEATHER_REFRESH_MS = 10 * 60 * 1000;

@Component({
  selector: 'app-header-info',
  templateUrl: './header-info.component.html',
  styleUrls: ['./header-info.component.scss'],
})
export class HeaderInfoComponent implements OnInit, OnDestroy {
  currentTime: string | undefined;
  weather: LocationWeather | null = null;
  locationAvailable = false;

  private destroyed$ = new Subject<void>();

  constructor(
    private clockService: ClockService,
    private geolocationService: GeolocationService,
    private weatherService: WeatherService,
  ) {}

  ngOnInit() {
    this.clockService
      .getCurrentTime24h()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((time) => (this.currentTime = time));

    interval(WEATHER_REFRESH_MS)
      .pipe(startWith(0), takeUntil(this.destroyed$))
      .subscribe(() => this.loadWeather());
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private loadWeather() {
    this.geolocationService
      .getCurrentPosition()
      .then((coordinates) => this.weatherService.getByCoordinates(coordinates).toPromise())
      .then((weather) => {
        this.weather = weather;
        this.locationAvailable = true;
      })
      .catch(() => (this.locationAvailable = false));
  }
}
